import { ToastShowingMode, ToastVariant } from '../../ui-kit/components/toast/enums';

export default () => ({
  title: '',
  isOpen: false,
  variant: ToastVariant.Info,
  showingMode: ToastShowingMode.Temporary,
});
